import React from 'react';
import {NavigationItems} from './NavigationItems';

export const Sidebar: React.FC = () => {
  return (
    <div data-testid="app-sidebar" className="hidden lg:fixed lg:inset-y-0 lg:left-0 lg:z-50 lg:block lg:w-20 lg:overflow-y-auto lg:bg-gray-900 lg:pb-4">
      <div className="flex h-16 shrink-0 items-center justify-center mt-4">
        <img className="h-16 w-auto" src="/logos/brandmark-white.png" alt="Yojo" />
      </div>
      <nav className="mt-8 flex flex-1">
        <NavigationItems />
      </nav>
    </div>
  );
};
